export default __webpack_public_path__ + "img/e442047d6b01e2ed2453a5ea4189d63d.png";